import React from 'react';
import "../../styles/profile/edit_profile.css";
import { useEffect, useState } from "react";
import { firebaseAuth, firebaseFirestore } from "../firebase/firebase_configuration";
import { onAuthStateChanged } from "firebase/auth";
import { doc, onSnapshot, updateDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { cloudinaryConfig } from "../cloudinary/cloudinary_config";
import Axios from "axios";
import ReactTooltip from 'react-tooltip';

import fromImage from "../../images/authentication/no_profile.png";
import cameraIcon from "../../images/profile/camera_icon.png";
import usernameIcon from "../../images/authentication/username_icon.png";
import bioIcon from "../../images/authentication/bio_icon.png";
import fullnameIcon from "../../images/profile/fullname_icon.png";

const EditProfile = () => {
    const goTo = useNavigate();
    const [getUserId, setUserId] = useState("");
    const [getUserFullName, setUserFullName] = useState("");
    const [getUserName, setUserName] = useState("");
    const [getUserBio, setUserBio] = useState("");
    const [getUserImage, setUserImage] = useState("");
    const [getUserBackdropImage, setUserBackdropImage] = useState("");
    const [updateProfile, setUpdateProfile] = useState(false);
    const [updateBackdropProfile, setUpdateBackdropProfile] = useState(false);

    const onEditProfile = async () => {
        if (getUserName === "") {
            alert("You have to set a username.");
        }else if (getUserName.length < 5) {
            alert("Username should be at least characters.");
        }else if (getUserFullName !== "" && getUserFullName.length < 7) {
            alert("Full name should be at least seven characters");
        }else{
            if (getUserImage === "" || getUserImage == null) {
                setUpdateProfile(true);
            }else{
                uploadImage(getUserImage, "profile").then(() => {
                    setUpdateProfile(true);
                });
            }

            if (getUserBackdropImage === "" || getUserBackdropImage == null) {
                setUpdateBackdropProfile(true);
            }else{
                uploadImage(getUserBackdropImage, "backdrop").then(() => {
                    setUpdateBackdropProfile(true);
                });
            }
            
        }
    }

    const uploadImage = async (image, type) => {
        try {
            const formData = new FormData();
            formData.append("file", image);
            formData.append("upload_preset", `${cloudinaryConfig.upload_preset}`);
            formData.append('folder', `user_profile_images/${getUserId}`);
            const imageResponse = await Axios.post(`https://api.cloudinary.com/v1_1/${cloudinaryConfig.cloud_name}/image/upload`, formData);

            const data = await imageResponse.data;
            if (data.secure_url) {
                if (type === "profile") {
                    setUserImage(data.secure_url);
                } else {
                    setUserBackdropImage(data.secure_url);
                }
            }else{
                alert(data)
            }
        } catch (error) {
            console.error('Error uploading image to Cloudinary:', error);
        }
    };

    const onDeleteImage = () => {
        if (getUserImage === "" || getUserImage == null) {
            alert("You have not set a profile image.");
        }else{
            // eslint-disable-next-line no-restricted-globals
            const shouldDelete = confirm("Are you sure you want to delete your profile image?");
            if (shouldDelete) {
                setUserImage("");
            }; 
        };
    };

    const onDeleteBackdropImage = () => {
        if (getUserBackdropImage === "" || getUserBackdropImage == null) {
            alert("You have not set a backdrop image.");
        } else {
            // eslint-disable-next-line no-restricted-globals
            const shouldDelete = confirm("Are you sure you want to delete your backdrop image?");
            if (shouldDelete) {
                setUserBackdropImage("");
            };
        };
    };

    const onChangeProfileImage = (e) => {
        const imageFile = e.target.files[0];
        if (imageFile) {
            const validImageTypes = ['image/jpeg', 'image/png', 'image/bmp', 'image/webp'];
            if (validImageTypes.includes(imageFile.type)) {
                const fileReader = new FileReader();
                fileReader.onloadend = () => {
                    setUserImage(fileReader.result);
                };
                fileReader.readAsDataURL(imageFile);
            } else {
                alert('Please select a valid image file (JPEG, PNG, BMP, WebP)');
            }
        };
    }

    const onChangeBackdropImage = (e) => {
        const imageFile = e.target.files[0];
        if (imageFile) {
            const validImageTypes = ['image/jpeg', 'image/png', 'image/bmp', 'image/webp'];
            if (validImageTypes.includes(imageFile.type)) {
                const fileReader = new FileReader();
                fileReader.onloadend = () => {
                    setUserBackdropImage(fileReader.result);
                };
                fileReader.readAsDataURL(imageFile);
            } else {
                alert('Please select a valid image file (JPEG, PNG, BMP, WebP)');
            }
        };
    }

    const onChangeFullName = (fullname) => {
        setUserFullName(fullname.target.value);
    };

    const onChangeUsername = (username) => {
        setUserName(username.target.value);
    };

    const onChangeBio = (bio) => {
        setUserBio(bio.target.value);
    };

    useEffect(() => {
        const doEdit = async () => {
            if (updateProfile && updateBackdropProfile) {
                try {
                    const userRef = doc(firebaseFirestore, 'User Details', getUserId);
                    await updateDoc(userRef, {
                        "fullname": getUserFullName,
                        "username": getUserName,
                        "bio": getUserBio,
                        "image": getUserImage,
                        "backdrop_image": getUserBackdropImage,
                    }).then(() => {
                        goTo("/main_back/profile");
                    });
                } catch (error) {
                    console.log(error.message);
                };
            };
        };

        doEdit();
    }, [updateProfile, updateBackdropProfile]);

    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userRef = doc(firebaseFirestore, 'User Details', getUserId); 
                const unsubscribe = onSnapshot(userRef, (docSnapshot) => {
                    if (docSnapshot.exists()) {
                        const userData = docSnapshot.data();
                        Object.keys(userData).forEach((fieldName) => {
                            if (fieldName.startsWith("fullname")) {
                                const fullNameListA = userData[fieldName];
                                setUserFullName(fullNameListA);
                            };

                            if (fieldName.startsWith("username")) {
                                const usernameListA = userData[fieldName];
                                setUserName(usernameListA);
                            };

                            if (fieldName.startsWith("image")) {
                                const imageListA = userData[fieldName];
                                setUserImage(imageListA);
                            };

                            if (fieldName.startsWith("backdrop_image")) {
                                const backdropImageListA = userData[fieldName];
                                setUserBackdropImage(backdropImageListA);
                            };

                            if (fieldName.startsWith("bio")) {
                                const bioListA = userData[fieldName];
                                setUserBio(bioListA);
                            };
                        });
                    };
                });
            
                return () => unsubscribe
            } catch (error) {
                console.log(`Error ${error}`);
            }
        };

        retrieveData();
    }, [getUserId]);

    useEffect(() => {
        document.getElementById("edit_profile_screen_header_container_backdrop").style.backgroundImage = `url(${getUserBackdropImage == null || getUserBackdropImage === "" ? null : getUserBackdropImage})`
    }, [getUserBackdropImage]);

    useEffect (() => {
        const isLoggedIn = onAuthStateChanged(firebaseAuth, (user) => {
          if (user) {
            setUserId(user.uid);
          }
        });
    
        return () => isLoggedIn();
    }, []);

    return(
        <div className="edit_profile_screen">
            <div className="profile_screen_header_container">
                <div id="edit_profile_screen_header_container_backdrop" className="edit_profile_screen_header_container_backdrop"></div>
                <div className="edit_profile_screen_header_container_overlay"></div>
                <div className="edit_profile_screen_header_container_content">
                    <div className="edit_profile_screen_header_container_row">
                        <div className="edit_profile_screen_header_container_image_container">
                            <img alt='profile' className="edit_profile_screen_header_container_image" src={getUserImage === "" || getUserImage == null ? fromImage : getUserImage} />
                            <div data-tip data-for="edit_image" className="edit_profile_screen_header_container_image_camera_con">
                                {/* <div className="edit_profile_screen_header_container_image_camera_overlay"></div> */}
                                <img alt='camera' className="edit_profile_screen_header_container_image_camera" src={cameraIcon} />
                                <input style={{cursor: "pointer"}} type="file" accept="image/*" onChange={onChangeProfileImage} className="edit_profile_screen_header_container_image_input" />
                            </div>
                            <ReactTooltip effect='solid' id="edit_image" place="top">Change profile image</ReactTooltip>
                        </div>

                        <p data-tip data-for="delete_image" onClick={onDeleteImage} className="edit_profile_screen_header_container_column_delete">Delete image</p>
                        {/* <img data-tooltip-id="delete_image" onClick={onDeleteImage} src={deleteIcon} className="edit_profile_screen_header_container_image_delete" /> */}
                        <ReactTooltip effect='solid' id="delete_image" place="top">Delete profile Image</ReactTooltip>
                    </div>
                    
                    <div className="edit_profile_screen_header_container_column">
                        <div className="edit_profile_screen_header_container_edit_con">
                            {/* <img data-tooltip-id="edit_backdrop" className="edit_profile_screen_header_container_edit" src={editIcon} /> */}
                            <p className="edit_profile_screen_header_container_column_edit_a">Change backdrop</p>
                            <ReactTooltip effect='solid' id="edit_backdrop" place="top">Change backdrop image</ReactTooltip>
                            <input data-tip data-for="edit_backdrop" type="file" accept="image/*" onChange={onChangeBackdropImage} className="edit_profile_screen_header_backdrop_input" />
                        </div>

                        <p data-tip data-for="delete_backdrop" onClick={onDeleteBackdropImage} className="edit_profile_screen_header_container_column_delete">Delete backdrop</p>
                        {/* <img data-tooltip-id="delete_backdrop" onClick={onDeleteBackdropImage} src={deleteIcon} className="edit_profile_screen_header_container_image_delete" /> */}
                        <ReactTooltip effect='solid' id="delete_backdrop" place="bottom">Delete backdrop image</ReactTooltip>
                    </div>
                </div>
            </div>

            <div className="edit_profile_screen_block">
                <div className="edit_profile_screen_search_input_container_i">
                    <div className="edit_profile_screen_search_input_container">
                        <img alt='name' src={fullnameIcon} className="edit_profile_screen_search_input_icon"/>
                        <input className="edit_profile_screen_search_input_field" id="item_section_search" placeholder={`Enter your full name`} type="text" value={getUserFullName} onChange={onChangeFullName} />
                    </div>
                </div> 

                <div className="edit_profile_screen_search_input_container_i">
                    <div className="edit_profile_screen_search_input_container">
                        <img alt='username' src={usernameIcon} className="edit_profile_screen_search_input_icon"/>
                        <input className="edit_profile_screen_search_input_field" id="item_section_search" placeholder={`Enter your username`} type="text" value={getUserName} onChange={onChangeUsername} />
                    </div>
                </div> 

                <div className="edit_profile_screen_search_input_container_i">
                    <div className="edit_profile_screen_search_input_container">
                        <img alt='bio' src={bioIcon} className="edit_profile_screen_search_input_icon"/>
                        <input className="edit_profile_screen_search_input_field" id="item_section_search" placeholder={`Enter a short description of yourself`} type="text" value={getUserBio} onChange={onChangeBio} />
                    </div>
                </div> 
                
                <div onClick={onEditProfile} className="edit_profile_button">
                    Edit Profile
                </div>
            </div>
        </div>
    );
};

export default EditProfile;